import styled, { css } from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

export const Content = styled.div`
  background-color: ${({ showMinimalComponentTreatment }) =>
    showMinimalComponentTreatment ? colors.pureWhite : colors.frostedGlass};
  padding: ${({ showMinimalComponentTreatment }) =>
    showMinimalComponentTreatment ? "12px" : "20px"};

  ${({ showMinimalComponentTreatment }) =>
    showMinimalComponentTreatment &&
    css`
      border-radius: 4px;
    `}
`;
